import { datadogRum } from '@datadog/browser-rum';
import React from 'react';

export class GlobalErrorBoundary extends React.Component {
  override componentDidCatch(error: Error, info: React.ErrorInfo) {
    const componentError = new Error(error.message);
    componentError.name = `React ErrorBoundary ${componentError.name}`;
    componentError.stack = info.componentStack;

    error.cause = componentError;

    datadogRum.addError(error, {
      is_crash: true,
    });
  }

  override render() {
    return this.props.children;
  }
}
